import { http, HttpResponse } from 'msw'

import type { PaymentMethod } from '@/@types/payment-method'

export const mockGetPaymentMethods = http.get<never>(
  '/my-business/api/agency/v1/payment-methods',
  () => {
    const paymentMethods: PaymentMethod[] = [
      {
        paymentMethodId: 1,
        name: 'Billing',
        code: 'BILLING',
      },
      {
        paymentMethodId: 2,
        name: 'Credit Card',
        code: 'CREDIT_CARD',
      },
      {
        paymentMethodId: 3,
        name: 'Direct',
        code: 'DIRECT',
      },
    ]

    return HttpResponse.json({ data: paymentMethods }, { status: 200 })
  },
)
